module.exports = __webpack_public_path__ + "/bundle/asset/admission2-2-440ec7a0cc352ce50cb9b6c6460f822f.png";